export default __webpack_public_path__ + "static/media/GreyInfoIcon.5c011981.svg";